import * as React from 'react';
import * as results from './style.module.scss';
import * as main from "../../../styles/main.module.scss";
export const Results = () => {
  return (
    <section className={results.results}>
      <div className="container">
        <h2 className={results.results__title}>
          Ваши результаты после прохождения курса:
        </h2>
        <ul className={results.results__list}>
          <li className={results.results__item}>
            <p>
              <span className={main.bgPurple}>Повышение скорости запоминания</span> любой информации минимум в&nbsp;2&nbsp;раза и ее сохранение в&nbsp;долговременной памяти
            </p>
          </li>
          <li className={results.results__item}>
            <p>
              <span className={main.bgPurple}>Усвоение</span> сложных текстов, классификаций, иностранных слов, иероглифов, номеров телефонов, дат и имён
            </p>
          </li>
          <li className={results.results__item}>
            <p>
              <span className={main.bgPurple}>Запоминание</span> от 100 иностранных слов в час
            </p>
          </li>
          <li className={results.results__item}>
            <p>
              <span className={main.bgPurple}>Мотивация на самообучение</span> и достижение намеченных целей за счет достижения результатов в ходе курса
            </p>
          </li>
        </ul>
      </div>
    </section>
  );
};
